import List from "@mui/material/List";
import { darken, lighten } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(List)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  //   height: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    width: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  "&:hover::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: theme.spacing(1),
    backgroundColor: darken(theme.palette.commonground.main, 0.4),
    backgroundClip: "content-box",
  },
  "&::-webkit-scrollbar-thumb": {
    opacity: "0.5",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
  },
}));

const OmniDialogMessage = props => {
  const { children, ...other } = props;
  return <CustomizedComponent {...other}>{children}</CustomizedComponent>;
};

export default OmniDialogMessage;
